import React, { useMemo, useState } from "react";

type ProductOption = {
  name: string;
  category: string;
  priceLabel: string;
};

const productOptions: ProductOption[] = [
  {
    name: "Pastel tres leches",
    category: "Pasteles",
    priceLabel: "Desde $25",
  },
  {
    name: "Cupcakes decorados",
    category: "Cupcakes",
    priceLabel: "Precio por docena",
  },
  {
    name: "Pan de banana",
    category: "Panes",
    priceLabel: "Precio según tamaño",
  },
  {
    name: "Pan de elote",
    category: "Panes",
    priceLabel: "Precio según tamaño",
  },
  {
    name: "Pan de naranja",
    category: "Panes",
    priceLabel: "Precio según tamaño",
  },
  {
    name: "Pan de frambuesa",
    category: "Panes",
    priceLabel: "Precio según tamaño",
  },
  {
    name: "Pan de chocolate",
    category: "Panes",
    priceLabel: "Precio según tamaño",
  },
  {
    name: "Pan de fresa",
    category: "Panes",
    priceLabel: "Precio según tamaño",
  },
  {
    name: "Postres individuales",
    category: "Postres",
    priceLabel: "Precio por unidad",
  },
  {
    name: "Flan",
    category: "Flanes",
    priceLabel: "Desde $6",
  },
  {
    name: "Chocoflan",
    category: "Flanes",
    priceLabel: "Precio según tamaño",
  },
  {
    name: "Gelatina de crema",
    category: "Gelatinas",
    priceLabel: "Precio según tamaño",
  },
  {
    name: "Gelatina marmoleada",
    category: "Gelatinas",
    priceLabel: "Precio según tamaño",
  },
];

const galleryItems = [
  { src: "/pastel1.png", alt: "Pastel de frutas", title: "Pastel de frutas" },
  {
    src: "/pastel2.png",
    alt: "Pastel cumpleaños",
    title: "Pastel cumpleaños",
  },
  { src: "/pastel3.png", alt: "Pastel decorado", title: "Pastel decorado" },
  {
    src: "/pastel4.png",
    alt: "Pastel con fresas",
    title: "Pastel con fresas",
  },
  { src: "/pastel5.png", alt: "Chocoflan", title: "Chocoflan" },
  {
    src: "/pastel6.png",
    alt: "Pastel chocolate",
    title: "Pastel chocolate",
  },
  { src: "/pastel7.png", alt: "Pastel floral", title: "Pastel floral" },
  { src: "/pastel8.png", alt: "Pastel especial", title: "Pastel especial" },
];

const cakeSizes = ["Pequeño", "Mediano", "Grande"];
const flanSizes = ["Individual", "Familiar", "Grande"];

export default function BakeryOrderApp() {
  const brandName = "La Cucharada Mágica";
  const slogan = "Endulzando tus momentos especiales";
  const whatsappNumber = "12099716345";

  const [customerName, setCustomerName] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(
    productOptions[0].name
  );
  const [quantity, setQuantity] = useState("1");
  const [cakeSize, setCakeSize] = useState("Mediano");
  const [flanSize, setFlanSize] = useState("Familiar");
  const [pickupDate, setPickupDate] = useState("");
  const [eventType, setEventType] = useState("");
  const [notes, setNotes] = useState("");

  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [selectedAlt, setSelectedAlt] = useState("");

  const selectedProductInfo = useMemo(() => {
    return (
      productOptions.find((item) => item.name === selectedProduct) ||
      productOptions[0]
    );
  }, [selectedProduct]);

  const selectedSize =
    selectedProduct === "Pastel tres leches" || selectedProduct === "Chocoflan"
      ? cakeSize
      : selectedProduct === "Flan"
      ? flanSize
      : "No aplica";

  const orderSummary = `
Cliente: ${customerName || "-"}
Teléfono: ${phone || "-"}
Producto: ${selectedProduct}
Categoría: ${selectedProductInfo.category}
Tamaño: ${selectedSize}
Cantidad: ${quantity || "-"}
Fecha de entrega: ${pickupDate || "-"}
Evento u ocasión: ${eventType || "-"}
Notas: ${notes || "-"}
Referencia de precio: ${selectedProductInfo.priceLabel}
`.trim();

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    orderSummary
  )}`;

  return (
    <div className="page">
      <header className="hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <span className="badge">Repostería artesanal en Modesto, CA</span>
          <h1>{brandName}</h1>
          <p className="hero-subtitle">{slogan}</p>
          <p className="hero-text">
            Pasteles, flanes, cupcakes, panes y postres hechos con amor para tus
            momentos especiales.
          </p>

          <div className="hero-actions">
            <a href="#pedido" className="primary-btn">
              Hacer pedido
            </a>
            <a href="#productos" className="secondary-btn">
              Ver productos
            </a>
          </div>
        </div>
      </header>

      <main className="container">
        <section className="intro-card">
          <div>
            <p className="section-kicker">Bienvenidos</p>
            <h2>Disfruta de los sabores de nuestra pastelería</h2>
            <p>
              Aquí, el sabor cobra vida y cada bocado es una experiencia
              inolvidable. Explora nuestros productos y envía tu pedido por
              WhatsApp de forma rápida.
            </p>
          </div>

          <div className="contact-card">
            <p className="section-kicker">Contáctanos</p>
            <p>WhatsApp: (209) 971-6345</p>
            <p>Pedidos con 2 días de anticipación.</p>
            <p>Atendemos pedidos personalizados para diferentes ocasiones.</p>
          </div>
        </section>

        <section id="productos" className="gallery-section">
          <h2>Nuestros productos</h2>
          <p
            className="hero-text"
            style={{ color: "#5b433e", margin: "0 0 20px" }}
          >
            Pasteles tres leches, cupcakes decorados, panes artesanales, flanes,
            chocoflanes, gelatinas y postres individuales.
          </p>

          <div className="features-grid">
            <div className="feature-card">
              <h3>Pasteles</h3>
              <p>
                Pasteles tres leches y personalizados para cumpleaños y eventos.
              </p>
            </div>

            <div className="feature-card">
              <h3>Cupcakes</h3>
              <p>Cupcakes decorados para fiestas, regalos y celebraciones.</p>
            </div>

            <div className="feature-card">
              <h3>Panes</h3>
              <p>Banana, elote, naranja, frambuesa, chocolate y fresa.</p>
            </div>

            <div className="feature-card">
              <h3>Flanes</h3>
              <p>
                Flanes tradicionales y chocoflanes con presentación especial.
              </p>
            </div>

            <div className="feature-card">
              <h3>Gelatinas</h3>
              <p>Gelatina de crema y gelatina marmoleada para toda ocasión.</p>
            </div>

            <div className="feature-card">
              <h3>Postres</h3>
              <p>Postres individuales listos para disfrutar y compartir.</p>
            </div>
          </div>
        </section>

        <section id="pedido" className="order-layout">
          <div className="form-card">
            <div className="form-grid">
              <div className="field">
                <label>Nombre</label>
                <input
                  placeholder="Tu nombre"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                />
              </div>

              <div className="field">
                <label>Teléfono</label>
                <input
                  placeholder="Tu teléfono"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="field full">
                <label>Producto</label>
                <select
                  value={selectedProduct}
                  onChange={(e) => setSelectedProduct(e.target.value)}
                >
                  {productOptions.map((product) => (
                    <option key={product.name} value={product.name}>
                      {product.name} — {product.priceLabel}
                    </option>
                  ))}
                </select>
              </div>

              {(selectedProduct === "Pastel tres leches" ||
                selectedProduct === "Chocoflan") && (
                <div className="field">
                  <label>Tamaño</label>
                  <select
                    value={cakeSize}
                    onChange={(e) => setCakeSize(e.target.value)}
                  >
                    {cakeSizes.map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {selectedProduct === "Flan" && (
                <div className="field">
                  <label>Tamaño</label>
                  <select
                    value={flanSize}
                    onChange={(e) => setFlanSize(e.target.value)}
                  >
                    {flanSizes.map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="field">
                <label>Cantidad</label>
                <input
                  placeholder="Ej. 1, 6, 12"
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </div>

              <div className="field">
                <label>Fecha de entrega</label>
                <input
                  type="date"
                  value={pickupDate}
                  onChange={(e) => setPickupDate(e.target.value)}
                />
              </div>

              <div className="field full">
                <label>Evento u ocasión</label>
                <input
                  placeholder="Cumpleaños, graduación, aniversario..."
                  value={eventType}
                  onChange={(e) => setEventType(e.target.value)}
                />
              </div>

              <div className="field full">
                <label>Notas</label>
                <textarea
                  rows={5}
                  placeholder="Escribe colores, decoración, mensaje, sabor o detalles especiales..."
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="summary-card">
            <div className="price-box">
              <span>Referencia</span>
              <strong style={{ fontSize: "24px" }}>
                {selectedProductInfo.priceLabel}
              </strong>
            </div>

            <div className="summary-text">{orderSummary}</div>

            <div className="summary-actions">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noreferrer"
                className="primary-btn full-btn"
              >
                Enviar pedido por WhatsApp
              </a>
            </div>

            <p className="mini-note">
              El precio final puede variar según tamaño, decoración y detalles
              personalizados.
            </p>
          </div>
        </section>

        <section className="gallery-section">
          <h2>Galería de trabajos</h2>

          <div className="gallery-grid">
            {galleryItems.map((item) => (
              <div
                key={item.src}
                className="gallery-card"
                onClick={() => {
                  setSelectedImage(item.src);
                  setSelectedAlt(item.alt);
                }}
                style={{ cursor: "pointer" }}
              >
                <img src={item.src} alt={item.alt} />
                <div className="gallery-card-content">
                  <h3>{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="features-grid">
          <div className="feature-card">
            <p>★★★★★ Excelente servicio</p>
          </div>
          <div className="feature-card">
            <p>★★★★★ Muy delicioso</p>
          </div>
          <div className="feature-card">
            <p>★★★★★ Lo recomiendo</p>
          </div>
        </section>
      </main>

      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="lightbox-close"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
            <img
              src={selectedImage}
              alt={selectedAlt}
              className="lightbox-image"
            />
            <p className="lightbox-caption">{selectedAlt}</p>
          </div>
        </div>
      )}

      <footer
        style={{
          background: "#2b1d1a",
          color: "white",
          padding: "30px",
          textAlign: "center",
          marginTop: "40px",
        }}
      >
        <h3>La Cucharada Mágica</h3>
        <p>Repostería artesanal en Modesto, CA</p>
        <p>WhatsApp: (209) 971-6345</p>

        <a
          href="https://instagram.com/repo.steriartesanal"
          target="_blank"
          rel="noreferrer"
          style={{ color: "#f9a8d4", display: "block", marginTop: "10px" }}
        >
          Síguenos en Instagram 📸
        </a>

        <p style={{ marginTop: "10px" }}>© 2026</p>
      </footer>
    </div>
  );
}
